"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseApiClient = void 0;
const axios_1 = __importDefault(require("axios"));
const IMTokenUtils_1 = require("../utils/IMTokenUtils");
class BaseApiClient {
    httpClient;
    host;
    imId;
    token;
    username;
    secretKey;
    hmacSha256;
    logger;
    constructor(params) {
        this.host = params.host;
        this.hmacSha256 = params.hmacSha256;
        this.logger = params.logger;
        this.imId = params.imId;
        const tokenContents = (0, IMTokenUtils_1.getIMTokenContents)(params.token);
        this.token = tokenContents.userToken;
        this.username = tokenContents.username;
        this.secretKey = tokenContents.secretKey;
        this.httpClient = axios_1.default.create({
            baseURL: params.host,
            timeout: params.timeout ?? 60000,
        });
    }
    /**
     * Makes an HTTP request to the API server.
     * @param {Methods} method The HTTP method to use.
     * @param {string} path The API endpoint path.
     * @param {Record<string, unknown>} [query] The query parameters for the request.
     * @param {unknown} [body] The request body.
     * @returns {Promise<T>} A Promise that resolves to the response data.
     */
    async request(method, path, query, body) {
        const time = new Date().getTime();
        const params = this.query(query);
        const paramsStr = new URLSearchParams(params).toString();
        const headers = this.headers(await this.hash(method, `${this.host}${path}${paramsStr ? `?${paramsStr}` : ''}`, time), time);
        if (this.logger) {
            this.logger
                .with({
                methodArgs: {
                    method,
                    path,
                    query,
                    body,
                    headers: {
                        ...headers,
                        Authorization: '',
                        Signature: '',
                    },
                },
            })
                .trace('MethodCall');
        }
        const requestObj = {
            method,
            url: path,
            headers,
            data: body,
            params,
        };
        const response = await this.httpClient.request(requestObj);
        if (this.logger) {
            this.logger
                .with({ extras: { response: response.data } })
                .trace('Response');
        }
        if (!response.data.success_code) {
            throw new Error(`IM ${method} ${path} ${response.data.error_code} ${response.data.message}`);
        }
        return response.data;
    }
    headers(hashedRequest, time) {
        return {
            Accept: 'application/json',
            'Accept-Encoding': 'gzip,deflate,br',
            Authorization: `Basic ${this.token?.toString()}`,
            Signature: hashedRequest,
            Timestamp: time,
            'X-Merchant-Pk': this.imId ?? '',
            'Content-Type': 'application/json',
        };
    }
    query(params) {
        if (!params) {
            return {};
        }
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            if (value !== null && value !== undefined) {
                result[key] = value.toString();
            }
        }
        return result;
    }
    async hash(method, url, time) {
        const stringToHash = `${method}|${url}|${time}`;
        const hashHex = await this.hmacSha256(this.secretKey, stringToHash);
        const hashHexFinal = await this.hmacSha256(this.username, hashHex);
        return hashHexFinal;
    }
    handleError(error) {
        throw error;
    }
}
exports.BaseApiClient = BaseApiClient;
